import script from "./CadastroTipoAtend.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroTipoAtend.vue?vue&type=script&setup=true&lang=js"

import "./CadastroTipoAtend.vue?vue&type=style&index=0&id=0ecce21d&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontpainel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ecce21d"]])

export default __exports__